<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div class="decorative-icon">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/menu.svg?alt=media&token=6cc87810-c0f8-41a0-a994-8ca4aa3813cf"
          />
        </div>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="top-title mt-0 mb-0 green text-xxl ion-text-uppercase">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
              />
              Lista de receitas
            </p>
            <p class="mt-1 mb-0 white text-sm dark">+ 1.500 receitas saudáveis e práticas pra você</p>
          </ion-col>
        </ion-row>
        <ion-row class="pt-3">
          <ion-col size="12">
            <div class="filter-button p-2">
              <div class="filter-button-content cursor-pointer" @click="gotoFilter">
                <p class="d-flex-align-center mb-0 mt-0">
                  <ion-icon name="infinite" mode="ios" class="mr-2"></ion-icon>
                  <span class>Filtrar</span>
                </p>
                <p
                  v-if="filtersOn"
                  class="text-xs mt-1 mb-0"
                >{{ filtersMeal }} &#183; {{ filtersRestrictions }} &#183; {{ filtersPreferences }}</p>
              </div>
              <div v-if="filtersOn" class="empty-button cursor-pointer" @click="emptyFilter">
                <ion-icon name="trash" mode="ios"></ion-icon>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="pt-3">
          <ion-col size="12">
            <div v-if="dishes.length > 0">
              <div class="dishes mt-2" v-for="dish in dishes" :key="dish.index">
                <div class="dish pt-0 pb-0 mb-2 cursor-pointer" @click="gotoDish(dish)">
                  <ion-item lines="none" no-padding>
                    <ion-avatar slot="start" class="dish-avatar">
                      <ion-img v-if="dish.data.picture" :src="dish.data.picture"></ion-img>
                      <ion-img
                        v-else
                        src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                      ></ion-img>
                    </ion-avatar>
                    <ion-label>
                      <p class="mt-0 mb-0 ion-text-uppercase text-xs">
                        {{ dish.data.kcal }} kcal
                        <span class="ion-text-lowercase grey">/ porção</span>
                      </p>
                      <p class="mt-0 mb-0 dark text-sm bold ion-text-wrap">{{ dish.data.namePT }}</p>
                    </ion-label>
                  </ion-item>
                  <div class="dish-icon">
                    <ion-icon mode="ios" name="arrow-dropright-circle" color="primary"></ion-icon>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p
                class="mt-5 mb-5 grey text-sm ion-text-center"
              >Ops, não encontramos nenhum receita com esses filtros :/</p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <TabBar
      mealsClass="tab-grey"
      shoppingClass="tab-grey"
      profileClass="tab-grey"
      recipesClass="white tab-green"
    />
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// tab bar
import TabBar from "../../partials/structural/TabBar.vue";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// rfdc
const clone = require("rfdc")();
// store
import store from "../../utils/store.js";
// utils
function translateMeal(meal) {
  let translatedMeal;
  if (meal === "breakfast") {
    translatedMeal = "Café-da-manhã";
  } else if (meal === "morningSnack") {
    translatedMeal = "Lanche da manhã";
  } else if (meal === "lunch") {
    translatedMeal = "Almoço";
  } else if (meal === "afternoonSnack") {
    translatedMeal = "Lanche da tarde";
  } else if (meal === "dinner") {
    translatedMeal = "Jantar";
  } else if (meal === "supper") {
    translatedMeal = "Ceia";
  } else {
    translatedMeal = "Todas as refeições";
  }
  return translatedMeal;
}
// component
export default {
  name: "RecipeBook",
  components: {
    TabBar,
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      filters: store.state.filters,
      filtersOn: false,
      filtersMeal: null,
      filtersRestrictions: [],
      filtersPreferences: [],
      dishes: []
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoFilter() {
      this.$router.push({
        name: "Filter Recipes"
      });
    },
    async emptyFilter() {
      const instance = this;
      instance.startLoading();
      instance.dishes = [];
      instance.filtersOn = false;
      store.state.filters = {
        meal: "all",
        restrictions: [],
        preferences: []
      };
      instance.filters = store.state.filters;
      try {
        let dishRef = db.collection("dishes");
        const snapshot = await dishRef.get();
        let dishList = [];
        snapshot.forEach(doc => {
          const dishObj = {
            id: doc.id,
            data: doc.data()
          };
          dishList.push(dishObj);
        });
        dishList.sort(function(a, b) {
          const textA = a.data.namePT.toUpperCase();
          const textB = b.data.namePT.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        instance.dishes = dishList;
        instance.isLoading = false;
      } catch (e) {
        console.log(e);
        instance.isLoading = false;
      }
    },
    gotoDish(dish) {
      this.$router.push({
        name: "Favorite Meal",
        params: {
          dishId: dish.id,
          proportion: 100
        }
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      // check if subscription is active
      if (!instance.profile.data.subscriptionStatus) {
        this.$router.push({
          name: "Subscribe"
        });
      }
      // get dishes
      dishRef = db.collection("dishes");
      const snapshot = await dishRef.get();
      let dishList = [];
      snapshot.forEach(doc => {
        const dishObj = {
          id: doc.id,
          data: doc.data()
        };
        dishObj.data.kcal = Math.floor(dishObj.data.kcal);
        dishList.push(dishObj);
      });
      let approvedDishes = clone(dishList);
      // run filters
      const filters = store.state.filters;
      let filterFlag, preferencesAdded;
      if (filters.meal !== "all") {
        filterFlag = true;
      }
      if (filters.restrictions.length > 0) {
        filterFlag = true;
      }
      if (filters.preferences.length > 0) {
        filterFlag = true;
      }
      let dishRef;
      let mealSelected;
      let restrictionsSelected = [];
      let vegan, vegetarian, lactoseFree, glutenFree;
      if (filterFlag) {
        // meals
        mealSelected = filters.meal;
        let mealToShow = translateMeal(mealSelected);
        instance.filtersOn = true;
        instance.filtersMeal = mealToShow;
        // restrictions
        if (filters.restrictions.length > 0 && filters.restrictions[0] !== "") {
          restrictionsSelected = filters.restrictions;
          for (let i = 0; i < restrictionsSelected.length; i++) {
            if (restrictionsSelected[i] === "vegan") {
              vegan = true;
              restrictionsSelected[i] = "Vegano";
            } else if (restrictionsSelected[i] === "vegetarian") {
              vegetarian = true;
              restrictionsSelected[i] = "Vegetariano";
            } else if (restrictionsSelected[i] === "lactoseFree") {
              lactoseFree = true;
              restrictionsSelected[i] = "Lactose-free";
            } else if (restrictionsSelected[i] === "glutenFree") {
              glutenFree = true;
              restrictionsSelected[i] = "Gluten-free";
            } else {
              //
            }
          }
          instance.filtersRestrictions = restrictionsSelected.join(", ");
          instance.filtersOn = true;
        } else {
          instance.filtersRestrictions = "sem restrições";
        }
        for (let i = approvedDishes.length - 1; i >= 0; i--) {
          // meals
          let mealsDish = [];
          let flagMeal;
          if (mealSelected !== "all") {
            if (approvedDishes[i].data.breakfast) {
              mealsDish.push("breakfast");
            }
            if (approvedDishes[i].data.morningSnack) {
              mealsDish.push("morningSnack");
            }
            if (approvedDishes[i].data.lunch) {
              mealsDish.push("lunch");
            }
            if (approvedDishes[i].data.afternoonSnack) {
              mealsDish.push("afternoonSnack");
            }
            if (approvedDishes[i].data.dinner) {
              mealsDish.push("dinner");
            }
            if (approvedDishes[i].data.supper) {
              mealsDish.push("supper");
            }
            flagMeal = mealsDish.includes(mealSelected);
          } else {
            flagMeal = true;
          }
          // restrictions
          let flagRestrictions = true;
          if (vegan) {
            if (!approvedDishes[i].data.nutritionalInfo.vegan) {
              flagRestrictions = false;
            }
          }
          if (vegetarian) {
            if (!approvedDishes[i].data.nutritionalInfo.vegetarian) {
              flagRestrictions = false;
            }
          }
          if (lactoseFree) {
            if (!approvedDishes[i].data.nutritionalInfo.lactoseFree) {
              flagRestrictions = false;
            }
          }
          if (glutenFree) {
            if (!approvedDishes[i].data.nutritionalInfo.glutenFree) {
              flagRestrictions = false;
            }
          }
          // preferences
          const preferences = clone(filters.preferences);
          let flagPreferences = true;
          if (preferences.length > 0) {
            const foods = approvedDishes[i].data.foods;
            for (let j = 0; j < foods.length; j++) {
              const ingredients = foods[j].data.ingredients;
              for (let k = 0; k < ingredients.length; k++) {
                for (let p = 0; p < preferences.length; p++) {
                  if (preferences[p].id === ingredients[k].id) {
                    preferences[p].found = true;
                  }
                }
              }
            }
            let preferencesToShow = [];
            for (let p = 0; p < preferences.length; p++) {
              preferencesToShow.push(preferences[p].namePT);
              if (!preferences[p].found) {
                flagPreferences = false;
              }
            }
            instance.filtersPreferences = preferencesToShow.join(", ");
            instance.filtersOn = true;
          } else {
            instance.filtersPreferences = "";
          }
          // splice
          if (!flagMeal || !flagRestrictions || !flagPreferences) {
            approvedDishes.splice(i, 1);
          }
        }
      }
      for (let i = approvedDishes.length - 1; i >= 0; i--) {
        const foods = approvedDishes[i].data.foods;
        if (foods.length === 1) {
          const ingredients = foods[0].data.ingredients;
          if (ingredients.length === 1) {
            approvedDishes.splice(i, 1);
          }
        }
      }
      approvedDishes.sort(function(a, b) {
        const textA = a.data.namePT.toUpperCase();
        const textB = b.data.namePT.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      instance.dishes = approvedDishes;
      instance.isLoading = false;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}
ion-content {
  --padding-bottom: 50px;
  --background: transparent !important;
}
ion-item {
  --padding-start: 10px;
}
.dish {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 15px;
}
.dish-avatar {
  height: 50px;
  width: 50px;
}
.dish-icon {
  width: 1.75rem;
}
.dish ion-icon {
  font-size: 1.75rem;
}
.dish {
  position: relative;
  width: 100%;
  border-radius: 50px;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}
.filter-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  border-radius: 15px;
  background: var(--ion-color-dark);
  color: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}
.filter-button-content {
  width: 100%;
}
.empty-button {
  font-size: 1.25rem !important;
  color: white;
}
</style>
